import { useState, useEffect } from "react";
import useFeatureTraits from "./useFeatureTraits";
import useCurrentTrip from "./useCurrentTrip";

const useSuggestionBanner = () => {
  const {
    traits: { bannerText, bannerAction },
  } = useFeatureTraits();
  const { currentTrip } = useCurrentTrip();
  const [hasSuggestionBanner, setHasSuggestionBanner] = useState(
    Boolean(bannerText) && Boolean(bannerAction)
  );
  const closeSuggestionBanner = () => setHasSuggestionBanner(false);

  useEffect(() => {
    setHasSuggestionBanner(Boolean(bannerText) && Boolean(bannerAction));
  }, [bannerAction, bannerText, currentTrip?.id]);

  return {
    hasSuggestionBanner: hasSuggestionBanner,
    closeSuggestionBanner,
  };
};

export default useSuggestionBanner;
